import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';

import * as store from '../../reducers/store';

export const DocumentHeader = () => {
  const documentTitle = useSelector((store: store.All) => store.documentTitle);
  const documentFavicon = useSelector(
    (store: store.All) => store.theme?.previsitFaviconUrl,
  );
  const themeTitle = useSelector(
    (store: store.All) => store.theme?.previsitPageTitle,
  );

  return (
    <Helmet>
      <meta charSet="utf-8" />
      <title>{documentTitle ?? themeTitle}</title>
      {documentFavicon ? (
        <link
          rel="icon"
          href={documentFavicon}
          type="image/x-icon"
          sizes="16x16"
        />
      ) : null}
    </Helmet>
  );
};
